// Use public path for LCP discoverability - matches preload in index.html
const PUBLIC_LOGO_PATH = "/logo.svg";

interface BrandedLoaderProps {
  message?: string;
  size?: "sm" | "md" | "lg";
}

export function BrandedLoader({ message = "Loading...", size = "md" }: BrandedLoaderProps) {
  const sizeClasses = {
    sm: "h-12 w-12",
    md: "h-20 w-20",
    lg: "h-28 w-28",
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-6">
      {/* Animated logo container */}
      <div className="relative">
        {/* Glow ring */}
        <div className="absolute inset-0 rounded-full bg-primary/20 blur-xl animate-pulse" />
        
        {/* Logo with pulse animation - fetchpriority high for LCP optimization */}
        <img
          src={PUBLIC_LOGO_PATH}
          alt="Alto"
          fetchPriority="high"
          loading="eager"
          decoding="sync"
          className={`${sizeClasses[size]} relative z-10 animate-pulse drop-shadow-[0_0_20px_hsl(var(--primary)/0.4)]`}
        />
      </div>

      {/* Loading indicator */}
      <div className="flex flex-col items-center gap-3">
        {/* Progress bar */}
        <div className="w-48 h-1.5 bg-muted rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-primary via-accent to-primary bg-[length:200%_100%] animate-[shimmer_1.5s_ease-in-out_infinite] rounded-full" />
        </div>
        
        {/* Message */}
        <p className="text-sm text-muted-foreground animate-pulse">{message}</p>
      </div>
    </div>
  );
}

// Inline skeleton loader for smaller sections
export function BrandedInlineLoader({ message }: { message?: string }) {
  return (
    <div className="flex items-center justify-center gap-3 p-8">
      <img
        src={PUBLIC_LOGO_PATH}
        alt="Alto"
        className="h-8 w-8 animate-pulse drop-shadow-[0_0_12px_hsl(var(--primary)/0.4)]"
      />
      {message && <p className="text-sm text-muted-foreground">{message}</p>}
    </div>
  );
}
